<div
  *ngIf="isVisible === true"
  class="tooltip box"
  [style.width.px]="width || undefined"
  [class.tooltip-top]="relativePosition === 'top'"
  [class.tooltip-left]="relativePosition === 'left'"
  [ngClass]="[
    'tooltip-' + theme,
    'tooltip-' + relativePosition,
    hideTip ? 'tooltip-hidden-tip' : '',
    hideShadow ? 'box--shadowless' : '',
    isLarge ? 'tooltip-large' : ''
  ]"
>
  <div (click)="closeTooltip()" [innerHTML]="text"></div>
</div>
